import { render } from "./App.vue?vue&type=template&id=ba16bc8e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ba16bc8e&lang=less"

import exportComponent from "D:\\AIDA\\dlvip-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__